var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-role-dropdown-component",class:[{'from-bottom' : _vm.fromBottom}, {'is-open' : _vm.open}]},[_c('ul',_vm._l((_vm.userRoles),function(role){return _c('li',{key:role.id},[_c('button',{attrs:{"role":"button"},on:{"click":function($event){return _vm.selectUserRole(role)}}},[_vm._v(_vm._s(role.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }